import { useSession } from './useSession';

export const useAlgoliaConfig = (pharmacyId?: string) => {
  const { session } = useSession(pharmacyId);

  return session?.algolia;
};
